import { render } from "./ReservasMes.vue?vue&type=template&id=c3521bb4&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"comensales\":\"data\",\"empresa_id\":\"data\",\"empresaId\":\"options\",\"isEmp143\":\"options\",\"isEmp82\":\"options\"}"
import script from "./ReservasMes.vue?vue&type=script&lang=js"
export * from "./ReservasMes.vue?vue&type=script&lang=js"

import "./ReservasMes.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script